import React, { Component } from 'react';
import { Grid, Row, Col, Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router';
import { Translate, Localize } from 'react-redux-i18n';

class Signup extends Component {
    handleFormSubmit(formProps) {
        this.props.signupUser(formProps);
    }

    // Error dealing.

    renderAlert() {
        if (this.props.errorMessage) {
            return (
                <div className="alert alert-danger">
                    <strong><Translate value="oops" />!</strong>{this.props.errorMessage}
                </div>
            )
        }
    }

    render() {
        const { handleSubmit, fields: { email, password, passwordConfirm }} = this.props;
        return (
            <div className="block-center mt-xl wd-xl">
                { /* START panel */ }
                <div className="panel panel-dark panel-flat">
                    <div className="panel-heading text-center">
                        <a href="#">
                            <img src="img/logo.png" alt="Image" className="block-center img-rounded" />
                        </a>
                    </div>
                    <div className="panel-body">
                        <p className="text-center pv">SIGNUP TO GET INSTANT ACCESS.</p>
                        <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } className="mb-lg">
                            <div className="form-group has-feedback">
                                <label htmlFor="signupInputEmail1" className="text-muted"><Translate value="email_address" /></label>
                                <input { ...email } id="signupInputEmail1" type="email" placeholder="Enter email" autoComplete="off" required="required" className="form-control" />
                                <span className="fa fa-envelope form-control-feedback text-muted"></span>
                                {email.touched && email.error && <div className="alert alert-danger">{email.error}</div>}
                            </div>
                            <div className="form-group has-feedback">
                                <label htmlFor="signupInputPassword1" className="text-muted"><Translate value="password" /></label>
                                <input { ...password } id="signupInputPassword1" type="password" placeholder="Password" autoComplete="off" required="required" className="form-control" />
                                <span className="fa fa-lock form-control-feedback text-muted"></span>
                                {password.touched && password.error && <div className="alert alert-danger">{password.error}</div>}
                            </div>
                            <div className="form-group has-feedback">
                                <label htmlFor="signupInputRePassword1" className="text-muted"><Translate value="retype_password" /></label>
                                <input { ...passwordConfirm }id="signupInputRePassword1" type="password" placeholder="Retype Password" autoComplete="off" required="required" data-parsley-equalto="#signupInputPassword1"
                                    className="form-control" />
                                <span className="fa fa-lock form-control-feedback text-muted"></span>
                                {passwordConfirm.touched && passwordConfirm.error && <div className="alert alert-danger">{passwordConfirm.error}</div>}
                            </div>
                            <div className="clearfix">
                                <div className="checkbox c-checkbox pull-left mt0">
                                    <label>
                                        <input type="checkbox" value="" required="required" name="agreed" />
                                        <em className="fa fa-check"></em><Translate value="msg_agree_terms" />
                                    </label>
                                </div>
                            </div>
                            <button action="submit" className="btn btn-block btn-primary mt-lg"><Translate value="create_account" /></button>
                        </form>
                        <p className="pt-lg text-center">Have an account?</p><Link to="/login" className="btn btn-block btn-default"><Translate value="login" /></Link>
                    </div>
                </div>
                { /* END panel */ }
            </div>

        );
    }

}

export default Signup;



// WEBPACK FOOTER //
// ./master/jsx/components/Auth/signup.jsx